import React from 'react'
import { IconProps } from '../../../common/types'

const ActivityLogsIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.37 9.567h5.25m-11.24 0 .75.75 2.25-2.25m2.99 8.5h5.25m-11.24 0 .75.75 2.25-2.25m5.62 7.62c5 0 7-2 7-7v-6c0-5-2-7-7-7H9c-5 0-7 2-7 7v6c0 5 2 7 7 7z"
      ></path>
    </svg>
  )
}

export default ActivityLogsIcon
